import { Round } from "@pdfking/math"
import { ZoomInIcon, ZoomOutIcon } from "lucide-react"

import { useTranslationTyped } from "../i18n/useTranslation"
import { RangeControl } from "./RangeControl"

// `zoom` is an inverse scale (units per pixel), while the control displays
// the corresponding direct percentage.
export function ZoomControl({ zoom, on_zoom }: { zoom: number; on_zoom: (zoom: number) => void }) {
  const pdfview = useTranslationTyped("pdfview")
  const percentage = Round(100 / zoom)

  return (
    <RangeControl
      decrement_icon={<ZoomOutIcon />}
      formatter={n => `${n}%`}
      increment_icon={<ZoomInIcon />}
      max={200}
      min={25}
      next_description={pdfview.ZOOM_IN()}
      on_value={n => on_zoom(100 / n)}
      previous_description={pdfview.ZOOM_OUT()}
      step={25}
      value={percentage}
      tooltip_side="bottom"
    />
  )
}
